import { Module } from "shared/components/Module";
import { tokens } from "shared/components/Spor";
import styled from "styled-components";

/**
 * Shared layout for the alternative transport left/right panels
 */

export const PanelHorizontalScroll = styled.div`
  flex: 1;
  min-height: 0;
  margin-right: -${tokens.default.size.spacing[2.5]};
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const PanelScrollContent = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 924px;
  display: flex;
  flex-direction: column;
  gap: ${tokens.default.size.spacing[2]};

  @container altTransportPage (width < 1696px) {
    min-width: 0;
  }
`;

export const PanelScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: none;
  display: flex;
  flex-direction: column;
  gap: ${tokens.default.size.spacing[2]};
  padding-top: ${tokens.default.size.spacing[3]};
  padding-right: ${tokens.default.size.spacing[2.5]};
`;

export const PanelModuleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(456px, 812px));
  gap: ${tokens.default.size.spacing[2]};
  align-items: start;
  padding-bottom: ${tokens.default.size.spacing[3]};

  @container altTransportPage (width < 1696px) {
    grid-template-columns: 1fr;
  }
`;

export const PanelHeaderDivider = styled.div`
  flex-shrink: 0;
  margin: 0 -${tokens.default.size.spacing[3]};
  padding: ${tokens.default.size.spacing[3]};
  border-bottom: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
`;

type BusModulePosition = "center" | "left" | "right";

// Handles borders and corners to tile better
const positionStyles = (position: BusModulePosition = "center") => {
  switch (position) {
    case "center":
      return "";
    case "left":
      return `
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      `;
    case "right":
      return `
        border-left: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      `;
  }
};

// use modulePosition prop to determine the position-specific styles if used alongside another busmodule
export const BusModule = styled(Module).attrs({ size: "lg" })<{
  modulePosition?: BusModulePosition;
}>`
  height: 100%;
  min-height: 0;
  && {
    border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
    ${({ modulePosition: $position }) => positionStyles($position)}
  }
`;
